module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='bbb';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/header/list/templates/navigation.html
// module id = 451
// module chunks = 0